export function addUnique(arr, value) {
  if (!arr.includes(value)) {
    arr.push(value);
  }
  return arr;
}
